export const MESSAGES = {
    MOBILE_VALIDATION: "Mobile number must be 10 digits",
    PIN_VALIDATION: "PIN must be 4 digits",
    REQUIRED: "This field is required",
    LOGIN_SUCCESS: "Login successful",
    LOGIN_FAILURE: "Login failed",
    INVALID_CREDENTIALS: "Invalid mobile number or PIN",
    SIGNUP_SUCCESS: "Sign up successful.",
    SIGNUP_FAILED: "Sign up failed. Please try again.",
    SIGNUP_ERROR: "An error occurred during sign up. Please try again.",
    INVALID_MAIL: "Invalid email address",
    ONLY_DIGITS: "Only digits are allowed",
    PIN_MATCH: "Passwords And Confirm Password must match",
    AFTER_REGISTRATION_MSG: "Contact Admin For Approval !",
};


const signupInputClass = "w-full";
export const SIGNUP_FIELDS = [
    {
        label: "First Name",
        name: "first_name",
        type: "text",
        css: signupInputClass,
    },
    {
        label: "Last Name",
        name: "last_name",
        type: "text",
        css: signupInputClass,
    },
    { label: "Email address", name: "email", type: "email", css: "w-full" },
    {
        label: "Mobile no.",
        name: "mobile",
        type: "text",
        css: "w-full",
        maxLength: 10,
    },
    {
        label: "Company Code",
        name: "company_code",
        type: "text",
        css: signupInputClass,
        maxLength: 10,
    },
];